// "use client";
// import React, { useEffect, useState } from "react";
// import TransactionTable from "../components/shared/table/DataTable";
// import Image from "next/image";
// import DashboardCard from "../components/shared/common/DashboardCard";
// import { useContracts } from "@/lib/contract";
// import { useAccount } from "wagmi";
// import { formatUnits } from "viem";
// const page = () => {
//   const { tokenContract, stakingContract } = useContracts();
//   const { address, isConnected } = useAccount();
//   const [balance, setBalance] = useState("0");
//   const [unStake, setUnStake] = useState("0");
//   const fetchBalance = async () => {
//     if (tokenContract?.read?.balanceOf && isConnected && address) {
//       const rawBalance = await tokenContract.read.balanceOf([address]);
//       const formatted = formatUnits(rawBalance as bigint, 18); // convert to readable format
//       const rawUnStake: any = await stakingContract?.read.stakes([address]);

//       if (rawUnStake) {
//         const unStake = formatUnits(rawUnStake[0] as bigint, 18); // convert to readable format
//         setUnStake(unStake);
//       }
//       setBalance(formatted);
//     }
//   };
//   useEffect(() => {
//     fetchBalance();
//   }, [tokenContract]);
//   const cardData = [
//     {
//       id: "stake",
//       label: "Available Tokens To Stake",
//       value: balance ? balance : 0,
//       icon: "/icons/s1.svg",
//     },
//     {
//       id: "unstake",
//       label: "Available Tokens To Unstake",
//       value: unStake ? unStake : 0,
//       icon: "/icons/s2.svg",
//     },
//     {
//       id: "claim",
//       label: "Available Tokens To Claim",
//       value: "1,093.5",
//       icon: "/icons/s3.svg",
//     },
//   ];
//   return (
//     <div className="container mx-auto my-32 text-white px-2 xl:px-0">
//       {/* <DashboardCard data={cardData} /> */}
//       <TransactionTable />
//     </div>
//   );
// };

// export default page;
"use client";
import React, { useEffect } from 'react'
import Image from 'next/image'
const page = () => {

  useEffect(() => {
    if (!sessionStorage.getItem('reloaded')) {
      sessionStorage.setItem('reloaded', 'true')
      window.location.reload()
    }
  }, [])


  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: '#0a0a0a',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      color: 'white',
      textAlign: 'center',
      gap: '16px',
    }}>
<Image
        src="/images/bg.png"
        alt="Background"
        fill
        style={{ objectFit: 'cover', opacity: 0.3, zIndex: 0 }}
      />
      {/* Header */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        padding: '12px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#111111',
        borderBottom: '1px solid #222222',
        boxSizing: 'border-box',
      }}>
        {/* Logo + Brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Image
            src="/images/logo.png"
            alt="BlackChain Logo"
            width={60}
            height={60}
          />
          <span style={{ fontSize: '1.6rem', fontWeight: 'bold' }}>
            Black<span style={{ color: '#ff3333' }}>Chain</span>
          </span>
        </div>

        {/* Right side buttons */}
        
      </div>

      {/* Maintenance Icons */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        marginBottom: '8px',
      }}>
        <span style={{ fontSize: '5rem', animation: 'spin 4s linear infinite' }}>⚙️</span>
        <span style={{ fontSize: '6rem' }}>🔧</span>
        <span style={{ fontSize: '5rem', animation: 'spin 4s linear infinite reverse' }}>⚙️</span>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

      {/* Centered content */}
      <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#ff3333' }}>
        🔧 Wartungsmodus 🔧
      </h1>
      <p style={{ fontSize: '1.2rem', color: '#cccccc' }}>
        Wir arbeiten gerade am Staking. Geben Sie uns etwas Zeit.
      </p>
    </div>
  )
}

export default page